module.exports = __webpack_public_path__ + "32c5eaff70b1bc10011b9f30f706d20a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-23.png
// module id = 3131
// module chunks = 0